import PropTypes from 'prop-types';

const propTypes = {
  interval: PropTypes.string,
  outputYear: PropTypes.number,
  outputMonth: PropTypes.number,
  outputDate: PropTypes.number,
  outputDayOfWeek: PropTypes.number,
  outputHour: PropTypes.number,
};

class Schedules {
  static propTypes = propTypes;
}

export default Schedules;
